module.exports = __webpack_public_path__ + "img/bluedown.3b646bb3.svg";